export default __webpack_public_path__ + "static/media/blog01.8c26c4b5.png";